(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-product"]) return;
  try {
    
if (!customElements.get('bd-video-embeds')) {
  customElements.define('bd-video-embeds', class extends HTMLElement {
    connectedCallback() {
      this.renderPlayers();
      this.observer = new MutationObserver(() => this.renderPlayers());
      this.observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    renderPlayers() {
      this.querySelectorAll('.bd-performance-videos a[href]').forEach((link) => {
        if (link.dataset.embedded) return;
        let url;
        try { url = new URL(link.href); } catch { return; }
        if (url.protocol !== 'https:') return;
        const host = url.hostname.replace(/^www\./, '');
        let player;
        if (host === 'youtube.com' || host === 'youtu.be') {
          const id = host === 'youtu.be' ? url.pathname.slice(1) : url.searchParams.get('v');
          if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) return;
          player = document.createElement('iframe');
          player.src = `https://www.youtube-nocookie.com/embed/${id}?rel=0&playsinline=1`;
          player.title = `${this.dataset.productTitle} — ${link.textContent.trim()}`;
          player.loading = 'lazy';
          player.allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen';
          player.allowFullscreen = true;
          player.referrerPolicy = 'strict-origin-when-cross-origin';
        } else if (
          (['cdn.shopify.com', 'video.wixstatic.com'].includes(host) && url.pathname.endsWith('.mp4')) ||
          (host === 'brotherspyrotechnics.com' && url.pathname === '/api/Resource/Files' && /^\d+$/.test(url.searchParams.get('fileId') || ''))
        ) {
          player = document.createElement('video');
          player.src = url.href;
          player.controls = true;
          player.playsInline = true;
          player.preload = 'metadata';
          player.setAttribute('aria-label', `${this.dataset.productTitle} — ${link.textContent.trim()}`);
        } else {
          return;
        }
        link.dataset.embedded = 'true';
        player.className = 'bd-embedded-player';
        const holder = document.createElement('div');
        holder.className = 'bd-video-frame';
        holder.append(player);
        const paragraph = link.closest('p');
        (paragraph || link).before(holder);
        if (paragraph) paragraph.classList.add('bd-video-fallback');
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
